var map = {
	"./18.png": 2573,
	"./21.png": 2803,
	"./Rectangle.png": 9361,
	"./arrow-right.png": 8585,
	"./begamble.png": 6939,
	"./casino-thesun.png": 381,
	"./check-circle.png": 9201,
	"./copy-two.png": 3316,
	"./copy.png": 2611,
	"./external-link.png": 9720,
	"./sportsbook-thesun.png": 4374,
	"./star.png": 6960,
	"./superdeporteCta.png": 4952,
	"./superdeporteCtaTwo.png": 6603,
	"./sweepstake-thesun.png": 60,
	"./talksport-mob.png": 6942,
	"./talksport.png": 2492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;